<i18n src="../../locales/lang.json"></i18n>

<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-10">
        <div v-show="showThumbnails == false">
          <select class="form-control fileselect" v-bind:id="'select_' +  getId()" data-fouc v-on:change="onChange" v-select>
            <option value="" style="">{{$t('select_from_media_lib')}}</option>
            <option v-for="option in fileInfos" :key="option.id" v-bind:value="option.url" v-bind:data-icon="option.extension">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div v-show="showThumbnails == true">
          <div class="wrapper" style="max-height:400px;overflow-y:scroll;">
            <ul class="image-card-grid">
              <li class="image-card text-center" v-if="im.extension == 'folder'" v-for="im in images">
                <img @click="folderclicked(im)" height="100" src="/Images/file_icons/folder.png" />
                <div class="text-center mb-1 card-title">{{im.title}}</div>
              </li>
              <li class="image-card text-center" v-if="im.extension == 'folder_up'" v-for="im in images">
                <img @click="folderclicked(im)" height="100" src="/Images/file_icons/folder_up.png" />
                <div class="text-center mb-1 card-title" style="margin-top:-5px;">Up</div>
              </li>
              <image-card @onclicked="onclicked" v-if="im.extension != 'folder' && im.extension != 'folder_up'" v-for="im in images"
                          :key="im.id"
                          :image="im" v-bind:selected="im == image" />
            </ul>
          </div>
        </div>
      </div>
      <div class="col-2">
        <button @click="showList" class="btn btn-ouline-light p-1">
          <i class='icon-list'></i>
        </button>
        <button @click="showImages" class="btn btn-ouline-light p-1">
          <i class='icon-grid'></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

  import UploadService from "../services/UploadFilesService";
  var fileInfos = [];
  var images = [];


export default {
  name: "upload-file-lib",
  components: {
    UploadService
  },
  props: {
    uid: {
      required: false,
      type: String,
      default: null
    },
  },
  data() {
    return {
      fileInfos,
      showThumbnails: false,
      images:[],
    };
  },
  methods: {

    showList() {
      this.showThumbnails = false;
      this.$forceUpdate();
    },
    showImages() {
      this.showThumbnails = true;
      this.$forceUpdate();
    },
    folderclicked(folder) {
      if (folder.url_n.indexOf("folder:") == 0) {
        this.loadFolder(folder.url_n.replace("folder:", ""));
      }
      else if (folder.url_n.indexOf("back") == 0) {
        this.loadFiles();
      }
      else {
        this.$emit('change', folder.url_n, folder.title);
      }
    },
    onclicked(im) {
      this.$emit('change', im.url_n, im.title);
    },
    onChange() {
      var val = $("#" + 'select_' + this.getId()).val();
      if (val.indexOf("folder:") == 0) {
        this.loadFolder(val.replace("folder:", ""));
      }
      else if (val.indexOf("back") == 0) {
        this.loadFiles();
      }
      else {
        this.$emit('change', val, $("#" + 'select_' + this.getId() + ' option:selected').text());
      }
    },
    getId() {
      return this._uid;
    },
    async loadFolder(id) {
      var thisContext = this;
      UploadService.getFolderFiles(id).then((response) => {
        var files = [{ name: "up", url: "back", extension: "folder_up", id: -1 }]
        var images = [{
          "extension": "folder_up",
          "id":-1,
          "title": "up",
          "url_n": "back",
        }];
        for (var i = 0; i < response.data.length; i++) {
          files.push(response.data[i]);
          //if (response.data[i].extension == "folder") {
            //response.data[i].url = "/Images/file_icons/folder.png"
          //}
          images.push(
            {
              "extension": response.data[i].extension,
              "id": response.data[i].id,
              "title": response.data[i].name,
              "ownername": "",
              "datetaken": "",
              "views": "",
              "url_n": response.data[i].url,
            });
        }
       
        Vue.set(thisContext, "fileInfos", files)
        Vue.set(thisContext, "images", images)
       
        thisContext.$forceUpdate();
        
      }).then(() => {

        $("#" + 'select_' + thisContext.getId()).select2('destroy');

        var tmp = function formatState_file2(icon) {
          var originalOption = icon.element;
          if (!icon.id) { return icon.text; }
          var $icon = '<img src="/images/file_icons/' + $(icon.element).data('icon') + '.png" style="width:20px !important; !important; margin-top:0px !important;float:left;margin-left:0px;margin-right:5px;" />' + icon.text;
          return $icon;
        }

        $("#" + 'select_' + thisContext.getId()).select2({
          templateResult: tmp,
          minimumResultsForSearch: Infinity,
          templateSelection: tmp,
          escapeMarkup: function (m) { return m; }
        });
      });
    },
    async loadFiles() {
      var thisContext = this;
      UploadService.getFilesAndFolders(this.uid, null).then((response) => {
        var files = JSON.parse(JSON.stringify(response.data));
        Vue.set(thisContext, "fileInfos", files)
        var images = [];
        for (var i = 0; i < response.data.length; i++) {
          //var isFolder = false;
          //if (response.data[i].extension == "folder") {
          //  response.data[i].url = "/Images/file_icons/folder.png";
          //}
          images.push(
            {
              "extension": response.data[i].extension,
              "id": response.data[i].id,
              "title": response.data[i].name,
              "ownername": "",
              "datetaken": "",
              "views": "",
              "url_n": response.data[i].url,
            });
        }

        Vue.set(thisContext, "images", images)

        thisContext.$forceUpdate();
      }).then(() => {

        $("#" + 'select_' + thisContext.getId()).select2('destroy');

        var tmp = function formatState_file2(icon) {
          var originalOption = icon.element;
          if (!icon.id) { return icon.text; }
          var $icon = '<img src="/images/file_icons/' + $(icon.element).data('icon') + '.png" style="width:20px !important; !important; margin-top:0px !important;float:left;margin-left:0px;margin-right:5px;" />' + icon.text;
          return $icon;
        }


        $("#" + 'select_' + thisContext.getId()).select2({
          templateResult: tmp,
          minimumResultsForSearch: Infinity,
          templateSelection: tmp,
          escapeMarkup: function (m) { return m; }
        });
      });
    },
    setUid(v) {
      this.uid = v;
    }
  }
  ,
  watch: {

  },
    mounted() {
    //alert('Loading files')
    //this.loadFiles();
  }
};
</script>

<style scoped>
  .image-card-grid {
    list-style: none;
    margin: .5rem 0;
    padding: 0;
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
  }

  .image-card {
    width: calc(33% - 1rem);
    @media only screen and (max-width: 799px) {
      width: calc(50% - 1rem);
    }

    @media only screen and (max-width: 549px) {
      width: 100%;
      margin: .5rem 0;
    }
  }

 
  .image-date-view-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .image-card:hover {
    cursor: pointer;
  }

  .card-title {
    margin-top: -15px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 90px;
    margin-left: auto;
    margin-right: auto;
  }

</style>



// WEBPACK FOOTER //
// src/components/upload/upload-file-lib.vue